export default "__VITE_ASSET__D1gC8skk__"